/* eslint-disable jsx-a11y/anchor-has-content */
import axios from "axios";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Card, Col, Table } from "reactstrap";
import { Btn } from "../../../../../AbstractElements";
import { addProjectsUploadHead } from "../../../../../Data/AppsData/UsersData";
import { UserEditTableProp } from "../../../../../Types/UsersType";
import CommonCardHeader from "../../../../../Utils/CommonComponents/CommonCardHeader";
import TableHead from "../../../../../Utils/CommonComponents/TableHead";
import { AddProjectsAndUploadTitle, Href } from "../../../../../Utils/Constants";
import { UserEditTableApi } from "../../../../../api";
import { toast } from "react-toastify";

export default function AddProjectsAndUpload() {
  const [data, setData] = useState<UserEditTableProp[]>([]);
  const fetchData = async () => {
    try {
      axios.get(UserEditTableApi).then((response) => {
        setData(response.data);
      });
    } catch (error) {
      toast.error("cancelled" + error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Col md={12}>
      <Card>
        <CommonCardHeader title={AddProjectsAndUploadTitle} titleClass="card-title" />
        <div className="table-responsive custom-scrollbar theme-scrollbar add-project">
          <Table className="card-table table-vcenter text-nowrap">
            <TableHead headeData={addProjectsUploadHead} />
            <tbody>
              {data.map((item, i) => (
                <tr key={i}>
                  <td>
                    <Link className="text-inherit" to={`${process.env.PUBLIC_URL}/applications/project/project-list`}>
                      {item.projectName}
                    </Link>
                  </td>
                  <td>{item.date}</td>
                  <td>
                    <span className="status-icon bg-success"></span>
                    {item.status}
                  </td>
                  <td>{item.price}</td>
                  <td className="text-end">
                    <a className="icon" href={Href}></a>
                    <Btn color="primary" size="sm">
                      <i className="fa fa-pencil"></i>
                    </Btn>
                    <a className="icon" href={Href}></a>
                    <Btn color="success" size="sm">
                      <i className="fa fa-link"></i>
                    </Btn>
                    <a className="icon" href={Href}></a>
                    <Btn color="danger" size="sm">
                      <i className="fa fa-trash"></i>
                    </Btn>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Card>
    </Col>
  );
}
